export default __webpack_public_path__ + "static/media/10.0d6eb6c7.jpg";